import { BreakpointObserver } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { map, Observable, switchMap } from 'rxjs';
import { GetActiveCustomerQuery } from 'src/app/common/generated-types';
import { GET_ACTIVE_CUSTOMER } from 'src/app/common/graphql/documents.graphql';
import { DataService } from '../../providers/data/data.service';
import { StateService } from '../../providers/state/state.service';
import { WishlistService } from '../../providers/wishlist/wishlist.service';

@Component({
    standalone: true,
    selector: 'vsf-mobile-bottom-nav',
    imports: [CommonModule, RouterModule, TranslocoModule],
    templateUrl: './mobile-bottom-nav.component.html',
    styleUrls: ['./mobile-bottom-nav.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileBottomNavComponent implements OnInit {
    private stateService = inject(StateService);
    private breakpointObserver = inject(BreakpointObserver);
    private wishlistService = inject(WishlistService);
    private dataService = inject(DataService);
    
    isMobile$: Observable<boolean>;
    wishlistItemCount$: Observable<number>;
    activeCustomer$: Observable<GetActiveCustomerQuery['activeCustomer']>;

    ngOnInit(): void {
        this.isMobile$ = this.breakpointObserver.observe([`(max-width: 1023px)`]).pipe(map((result) => result.matches));
        this.wishlistItemCount$ = this.wishlistService.wishlistItems.pipe(
            map((items) => items.length)
        );
        const getActiveCustomer$ = this.dataService.query<GetActiveCustomerQuery>(GET_ACTIVE_CUSTOMER, {}, 'network-only');
        this.activeCustomer$ = this.stateService.select(state => state.signedIn).pipe(
            switchMap(() => getActiveCustomer$),
            map(data => data && data.activeCustomer),
        );
    }

    openKatalog() {
        this.stateService.setState('mobileNavMenuIsOpen', true);
    }

    userName(customer: NonNullable<GetActiveCustomerQuery['activeCustomer']>): string {
        const { firstName, lastName, emailAddress, customFields } = customer;
        if (customFields?.isCompany) {
            return customFields.companyName || emailAddress;
        } else if (firstName && lastName) {
            return `${firstName} ${lastName}`;
        } else {
            return emailAddress;
        }
    }
}
